import { render, staticRenderFns } from "./TurnplateLottery.vue?vue&type=template&id=0d5d2dbc&scoped=true"
import script from "./TurnplateLottery.vue?vue&type=script&lang=js"
export * from "./TurnplateLottery.vue?vue&type=script&lang=js"
import style0 from "./TurnplateLottery.vue?vue&type=style&index=0&id=0d5d2dbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d2dbc",
  null
  
)

export default component.exports